const Style = {

  label: 'mb-1',
  bar: 'w-full h-2 mb-4 bg-slate-100 rounded-sm overflow-hidden',
  fill: 'h-full ease-in-out duration-500 bg-green-500',

}

export default Style;